import { UserIcon, UsersThreeIcon } from "@phosphor-icons/react";
import { useI18N } from "common/hooks";

import OnboardingChoiceStep from "../components/OnboardingChoiceStep";
import { ONBOARDING_AUDIENCE_OPTIONS } from "../constants";
import { useOnboardingFlow } from "../state/useOnboardingFlow";
import type { OnboardingAudience } from "../types";

const ICONS = {
  myself: UserIcon,
  someone_i_care_for: UsersThreeIcon,
} as const;

/**
 * Step 2 of 4 — "Who are you here for?".
 *
 * Individual path only. A business owner is not answering for themselves or
 * someone they care for, so native's claim branch skips straight past this —
 * @see `ONBOARDING_SEQUENCE_BUSINESS`.
 */
const AudienceStep = () => {
  const i18n = useI18N();
  const { answers, updateAnswers } = useOnboardingFlow();

  return (
    <OnboardingChoiceStep<OnboardingAudience>
      groupName="onboarding-audience"
      title={i18n.get("onboardingAudienceTitle")}
      subtitle={i18n.get("onboardingAudienceSubtitle")}
      options={ONBOARDING_AUDIENCE_OPTIONS}
      icons={ICONS}
      value={answers.audience}
      onSelect={(audience) => updateAnswers({ audience })}
    />
  );
};

export default AudienceStep;
